import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import Styles from './videos-styles.scss';
import { AlertMessage, ButtonBack, ButtonKVBase, PlayVideoIcon } from '@/presentation/components';
import { useRecoilState } from 'recoil';
import { lessonState } from '@/presentation/pages/lessons/components/atoms';
import { useNavigate, useParams } from 'react-router';
import useLessons from '@/presentation/hooks/use-lessons';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import useUserSesssion from '@/presentation/hooks/use-user-session';
const Videos = ({ title = 'Needs vs. Wants for kids and Teens', manageProgressService, loadLessons }) => {
    const [state, setState] = useRecoilState(lessonState);
    const [activeButton, setActiveButton] = useState(false);
    const [duration, setDuration] = useState(0);
    const [video, setVideo] = useState(null);
    const { showCustomError } = useCustomToast();
    const { menuItemsState } = useLessons({ manageProgressService, loadLessons, Styles });
    const { user } = useUserSesssion();
    const { idModule, idVideo } = useParams();
    const navigate = useNavigate();
    const { lesson, menuItems } = state;
    useEffect(() => {
        if (idVideo) {
            const findVideoById = lesson.lessonsVideos.find(video => (video === null || video === void 0 ? void 0 : video.id) === Number(idVideo));
            if (findVideoById)
                setVideo(findVideoById);
        }
    }, [lesson, menuItems]);
    const activeButtonOnVideo = (state) => {
        const { playedSeconds } = state;
        const percentageWatched = (playedSeconds / duration) * 100;
        if (percentageWatched >= 90) {
            setActiveButton(true);
        }
    };
    return (React.createElement(React.Fragment, null, !state.isLoading && state.lesson && (React.createElement("div", { className: Styles.videoWrap },
        React.createElement("div", { className: Styles.title },
            React.createElement(ButtonBack, { text: "Module", btnBackgroundGradient: "transparent", onClick: () => {
                    navigate(`${user.role.description === 'Teacher'
                        ? `/teacher-dashboard/modules/${idModule}`
                        : `/student-dashboard/my-modules/${idModule}`}`);
                } }),
            React.createElement("div", { className: Styles.texts },
                React.createElement("span", null,
                    "Lesson ", lesson === null || lesson === void 0 ? void 0 :
                    lesson.id),
                React.createElement("h3", null, lesson === null || lesson === void 0 ? void 0 : lesson.name))),
        React.createElement("div", { className: Styles.content },
            React.createElement("div", { className: Styles.header },
                React.createElement("span", { className: Styles.icon },
                    React.createElement(PlayVideoIcon, { width: "42", height: "42" })),
                React.createElement("div", { className: Styles.headerTexts },
                    React.createElement("span", null, "Video"),
                    React.createElement("h3", null, video === null || video === void 0 ? void 0 : video.name))),
            React.createElement("div", { className: Styles.video }, video && video.link && (React.createElement(ReactPlayer, { url: video === null || video === void 0 ? void 0 : video.link, controls: true, className: Styles.reactPlayer, width: "100%", height: "100%", fallback: React.createElement("div", null, "Loading..."), onError: () => {
                    showCustomError('Error', 'Error loading video');
                }, onProgress: activeButtonOnVideo, onDuration: (duration) => {
                    setDuration(duration);
                } }))),
            React.createElement("div", { className: Styles.description },
                React.createElement("p", null, video === null || video === void 0 ? void 0 : video.description)),
            React.createElement("div", { className: "d-flex justify-content-center align-items-center ", style: { gap: 10 } },
                React.createElement("div", { className: Styles.alert },
                    React.createElement(AlertMessage, { noIcon: true, message: React.createElement("div", { style: { padding: '0.4rem' } },
                            React.createElement("div", { className: Styles.textInfo2, style: { paddingBottom: 8 } }, "To enable closed captions in another language:"),
                            React.createElement("ul", { className: Styles.textInfo2 },
                                React.createElement("li", null,
                                    "Click the ",
                                    React.createElement("strong", null, "settings"),
                                    " icon on the video."),
                                React.createElement("li", null,
                                    "Select ",
                                    React.createElement("strong", null, "Subtitles/CC"),
                                    "."),
                                React.createElement("li", null,
                                    "Choose ",
                                    React.createElement("strong", null, "Auto-translate"),
                                    " and select your language."))) })),
                React.createElement("div", { className: Styles.alert },
                    React.createElement(AlertMessage, { message: "You must watch the entire video to continue." }))),
            React.createElement("span", { className: Styles.divider }),
            React.createElement("div", { className: Styles.buttons },
                React.createElement("div", { className: Styles.left },
                    React.createElement(ButtonBack, { btnBackgroundGradient: "white", onClick: () => {
                            if (menuItemsState) {
                                const previous = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
                                if (previous > 0) {
                                    menuItemsState[previous - 1].onClick();
                                }
                            }
                        }, text: "Previous" })),
                React.createElement("div", { className: Styles.right },
                    React.createElement("div", { className: Styles.button },
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: " linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", disabled: !activeButton, onClick: () => {
                                if (menuItemsState) {
                                    const next = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
                                    if (menuItemsState[next]) {
                                        menuItemsState[next].onFinish();
                                    }
                                    if (next < menuItemsState.length - 1) {
                                        menuItemsState[next + 1].onClick();
                                    }
                                    setDuration(0);
                                    setActiveButton(false);
                                }
                            } }, "Next")))))))));
};
export default Videos;
